import React from 'react'
import { useConfetti } from '@root/hooks/useConfetti'

interface UseCelebrationProps {
  shouldCelebrate: boolean
}

// Fires a single confetti burst around the container once onboarding is completed.
export const useCelebration = ({ shouldCelebrate }: UseCelebrationProps) => {
  const containerRef = React.useRef<HTMLDivElement>(null)
  const hasCelebratedRef = React.useRef(false)
  const triggerConfetti = useConfetti({})

  React.useLayoutEffect(() => {
    if (!shouldCelebrate || hasCelebratedRef.current) return

    const rect = containerRef.current?.getBoundingClientRect()
    if (!rect) return

    hasCelebratedRef.current = true

    const left = rect.left / window.innerWidth
    const right = rect.right / window.innerWidth
    const top = rect.top / window.innerHeight
    const bottom = rect.bottom / window.innerHeight
    const centerX = (left + right) / 2
    const centerY = (top + bottom) / 2

    triggerConfetti({ particleCount: 100, spread: 70, origin: { y: centerY, x: centerX } })

    triggerConfetti({
      particleCount: 60,
      spread: 90,
      startVelocity: 30,
      origin: { y: centerY, x: left }
    })

    triggerConfetti({
      particleCount: 60,
      spread: 90,
      startVelocity: 30,
      origin: { y: centerY, x: right }
    })

    triggerConfetti({
      particleCount: 50,
      spread: 120,
      startVelocity: 25,
      origin: { y: top, x: centerX }
    })
  }, [shouldCelebrate, triggerConfetti])

  return { containerRef }
}
